import { render, staticRenderFns } from "./ProductsSearch.vue?vue&type=template&id=75c980c4&scoped=true&"
import script from "./ProductsSearch.vue?vue&type=script&lang=js&"
export * from "./ProductsSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSearch.vue?vue&type=style&index=0&id=75c980c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c980c4",
  null
  
)

export default component.exports